function escapeHtmlWithLineBreaks(value) {
    return value
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('\n', '<br/>');
}
export function buildFeedbackEmailHtml(details) {
    const escapedDescription = escapeHtmlWithLineBreaks(details.description);
    const refNumber = details.referenceNumber || '';
    const hasRef = refNumber.length > 0;
    const isIssue = details.type === 'issue';
    const introText = isIssue
        ? `Hello,<br/><br/>Thank you for reporting this issue. We've received the defect submission and our team will review it with focus and urgency.<br/><br/>The issue will be triaged to understand impact, reproduce the behavior where needed, identify the likely root cause, and determine the appropriate resolution path. We appreciate you sharing the details, as this helps us improve product stability, quality, and user experience.`
        : `Hello,<br/><br/>Thank you for sharing your enhancement request. We've received it and your input is now with the appropriate team for review.<br/><br/>Our product and engineering teams will evaluate the request, assess impact and priority, and determine the best path forward. Your feedback helps us continue improving the experience and ensuring we focus on the enhancements that matter most.`;
    const typeValue = isIssue ? 'Defect' : 'Enhancement';
    const subjectText = isIssue
        ? `We're investigating your reported issue`
        : `Your request is in motion`;
    const subject = hasRef ? `${subjectText} - ${refNumber}` : subjectText;
    const nextStepsText = isIssue
        ? `We will triage the issue, assess severity and impact, and route it to the appropriate team for investigation and resolution. If more information is needed to reproduce or diagnose the issue, the team will reach out. Updates will be shared through the appropriate support or delivery channel.`
        : `We will review the request, assess feasibility and priority, and route it for the right next steps. If additional details are needed, the team will reach out. Once reviewed, we will provide updates through the appropriate support or delivery channel.`;
    const closingText = isIssue
        ? `Thank you for helping us strengthen the applications.`
        : `Thank you for helping us make our applications better.`;
    const referenceNumberRow = hasRef
        ? `<tr>
<td style="padding:12px 16px;font-size:13px;font-weight:700;color:#555555;border-bottom:1px solid #e0e0e0;width:180px;vertical-align:top;">Reference Number</td>
<td style="padding:12px 16px;font-size:13px;color:#333333;border-bottom:1px solid #e0e0e0;">${refNumber}</td>
</tr>`
        : '';
    return `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8"/>
<meta name="viewport" content="width=device-width, initial-scale=1.0"/>
</head>
<body style="margin:0;padding:0;background-color:#f5f5f5;font-family:Arial,Helvetica,sans-serif;">
<table width="100%" cellpadding="0" cellspacing="0" style="background-color:#f5f5f5;padding:20px 0;">
<tr><td align="center">
<table width="600" cellpadding="0" cellspacing="0" style="background-color:#ffffff;border-radius:4px;overflow:hidden;">

<!-- Header -->
<tr>
<td style="background-color:#2d2d2d;padding:24px 32px;">
<span style="color:#ffffff;font-size:22px;font-weight:700;font-family:Arial,Helvetica,sans-serif;">Deloitte<span style="color:#86BC25;">.</span></span>
</td>
</tr>

<!-- Green Line -->
<tr>
<td style="height:8px;background-color:#86BC25;font-size:0;line-height:0;">&nbsp;</td>
</tr>

<!-- Intro Text -->
<tr>
<td style="padding:24px 32px 16px 32px;color:#333333;font-size:14px;line-height:1.6;">
${introText}
</td>
</tr>

<!-- Summary Header -->
<tr>
<td style="padding:0 32px 8px 32px;color:#333333;font-size:14px;font-weight:700;line-height:1.6;">
Summary of your request:
</td>
</tr>

<!-- Details Table -->
<tr>
<td style="padding:0 32px 24px 32px;">
<table width="100%" cellpadding="0" cellspacing="0" style="border:1px solid #e0e0e0;border-radius:4px;">

${referenceNumberRow}

<tr>
<td style="padding:12px 16px;font-size:13px;font-weight:700;color:#555555;border-bottom:1px solid #e0e0e0;width:180px;vertical-align:top;">Type</td>
<td style="padding:12px 16px;font-size:13px;color:#333333;border-bottom:1px solid #e0e0e0;">${typeValue}</td>
</tr>

<tr>
<td style="padding:12px 16px;font-size:13px;font-weight:700;color:#555555;border-bottom:1px solid #e0e0e0;width:180px;vertical-align:top;">Subject</td>
<td style="padding:12px 16px;font-size:13px;color:#333333;border-bottom:1px solid #e0e0e0;">${subject}</td>
</tr>

<tr>
<td style="padding:12px 16px;font-size:13px;font-weight:700;color:#555555;width:180px;vertical-align:top;">Description</td>
<td style="padding:12px 16px;font-size:13px;color:#333333;">${escapedDescription}</td>
</tr>

</table>
</td>
</tr>

<!-- Next Steps -->
<tr>
<td style="padding:0 32px 8px 32px;color:#333333;font-size:14px;font-weight:700;line-height:1.6;">
What happens next?
</td>
</tr>
<tr>
<td style="padding:0 32px 24px 32px;color:#333333;font-size:14px;line-height:1.6;">
${nextStepsText}
</td>
</tr>

<!-- Closing -->
<tr>
<td style="padding:0 32px 24px 32px;color:#333333;font-size:14px;line-height:1.6;">
${closingText}
</td>
</tr>

</table>
</td></tr>
</table>
</body>
</html>`;
}
export function buildFeedbackOwnerEmailHtml(details) {
    const escapedDescription = escapeHtmlWithLineBreaks(details.description);
    const refNumber = details.referenceNumber || '';
    const hasRef = refNumber.length > 0;
    const typeValue = details.type === 'issue' ? 'Defect' : 'Enhancement';
    const submittedBy = `${details.submittedBy.name} (${details.submittedBy.email})`;
    const referenceNumberRow = hasRef
        ? `<tr>
<td style="padding:12px 16px;font-size:13px;font-weight:700;color:#555555;border-bottom:1px solid #e0e0e0;width:180px;vertical-align:top;">Reference Number</td>
<td style="padding:12px 16px;font-size:13px;color:#333333;border-bottom:1px solid #e0e0e0;">${refNumber}</td>
</tr>`
        : '';
    return `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8"/>
<meta name="viewport" content="width=device-width, initial-scale=1.0"/>
</head>
<body style="margin:0;padding:0;background-color:#f5f5f5;font-family:Arial,Helvetica,sans-serif;">
<table width="100%" cellpadding="0" cellspacing="0" style="background-color:#f5f5f5;padding:20px 0;">
<tr><td align="center">
<table width="600" cellpadding="0" cellspacing="0" style="background-color:#ffffff;border-radius:4px;overflow:hidden;">

<tr>
<td style="background-color:#2d2d2d;padding:24px 32px;">
<span style="color:#ffffff;font-size:22px;font-weight:700;font-family:Arial,Helvetica,sans-serif;">Deloitte<span style="color:#86BC25;">.</span></span>
</td>
</tr>

<tr>
<td style="height:8px;background-color:#86BC25;font-size:0;line-height:0;">&nbsp;</td>
</tr>

<tr>
<td style="padding:24px 32px 16px 32px;color:#333333;font-size:14px;line-height:1.6;">
A new feedback request has been submitted and requires follow-up.
</td>
</tr>

<tr>
<td style="padding:0 32px 8px 32px;color:#333333;font-size:14px;font-weight:700;line-height:1.6;">
Feedback details:
</td>
</tr>

<tr>
<td style="padding:0 32px 24px 32px;">
<table width="100%" cellpadding="0" cellspacing="0" style="border:1px solid #e0e0e0;border-radius:4px;">

${referenceNumberRow}

<tr>
<td style="padding:12px 16px;font-size:13px;font-weight:700;color:#555555;border-bottom:1px solid #e0e0e0;width:180px;vertical-align:top;">Application</td>
<td style="padding:12px 16px;font-size:13px;color:#333333;border-bottom:1px solid #e0e0e0;">${details.applicationName}</td>
</tr>

<tr>
<td style="padding:12px 16px;font-size:13px;font-weight:700;color:#555555;border-bottom:1px solid #e0e0e0;width:180px;vertical-align:top;">Type</td>
<td style="padding:12px 16px;font-size:13px;color:#333333;border-bottom:1px solid #e0e0e0;">${typeValue}</td>
</tr>

<tr>
<td style="padding:12px 16px;font-size:13px;font-weight:700;color:#555555;border-bottom:1px solid #e0e0e0;width:180px;vertical-align:top;">Submitted by</td>
<td style="padding:12px 16px;font-size:13px;color:#333333;border-bottom:1px solid #e0e0e0;">${submittedBy}</td>
</tr>

<tr>
<td style="padding:12px 16px;font-size:13px;font-weight:700;color:#555555;width:180px;vertical-align:top;">Description</td>
<td style="padding:12px 16px;font-size:13px;color:#333333;">${escapedDescription}</td>
</tr>

</table>
</td>
</tr>

</table>
</td></tr>
</table>
</body>
</html>`;
}
